// Log metadata, never asset bodies or per-frame/per-pixel work. Debug output is
// always available through the browser console's Verbose/Debug filter.
export function errorMessage(error, fallback = "Unknown error") {
    if (typeof error === "string" && error.trim()) return error;
    if (typeof error?.message === "string" && error.message.trim()) return error.message;
    if (error?.error && error.error !== error) return errorMessage(error.error, fallback);
    return fallback;
}

export function errorDetails(error, fallback) {
    const cause = error?.error ?? error;
    return {
        message: errorMessage(error, fallback),
        name: cause?.name,
        stack: cause?.stack,
        event: error?.type,
        filename: error?.filename,
        line: error?.lineno,
        column: error?.colno,
    };
}

export function logger(scope) {
    const prefix = `[SaxtonHellLive:${scope}]`;
    return {
        debug: (event, details = {}) => console.debug(`${prefix} ${event}`, details),
        info: (event, details = {}) => console.info(`${prefix} ${event}`, details),
        warn: (event, details = {}) => console.warn(`${prefix} ${event}`, details),
        error: (event, error, details = {}) => console.error(`${prefix} ${event}`, {
            ...details, ...errorDetails(error, details.message),
        }),
    };
}
